<template>
  <div style="background: red;">
    <div :class="['SystemMessage', onSlowlyUnfold? 'SlowlyUnfold' : 'hidelyUnfold']">
        <p>{{SystemMessageInfo.SystemMessageInfos.text}}<span>{{days}}</span>天<span>{{hours}}</span>小时<span>{{minutes}}</span>分钟<span>{{seconds}}</span>秒{{SystemMessageInfo.SystemMessageInfos.text2}}</p>
        <i class="iconfont icon-icon_6" @click="closeTips"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SystemMessage',
  props: {
    SystemMessageInfo: Object
  },
  data: function () {
    return {
      myMsg: '首页',
      onSlowlyUnfold: true,
      timer: null,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.iScountDown()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    iScountDown () {
      const times = this.SystemMessageInfo.SystemMessageInfos.date
      const now = new Date()
      const distance = new Date(times) - now
      if (distance > 0) {
        this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const remainingHours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.hours = remainingHours
        const remainingMinutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        this.minutes = remainingMinutes < 10 ? '0' + remainingMinutes : remainingMinutes
        const remainingSeconds = Math.floor((distance % (1000 * 60)) / 1000)
        this.seconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds
      } else {
        clearInterval(this.timer)
      }
    },
    closeTips () {
      this.onSlowlyUnfold = false
    }
  },
  computed: {
  }
}
</script>
<style scoped>
.SystemMessage{width: 100%;height: 30px;text-align: center;padding: 0;margin: 0 auto;line-height: 30px;transition: all 300ms;background: red;color: white;}
.SystemMessage p{display: table;transition: all 1000ms;}
.SystemMessage i{margin-left: 20px;color: rgba(255, 255, 255, 0.5);font-size: 17px;cursor: pointer;transition: all 1000ms;vertical-align: middle;color: rgba(255, 255, 255, 0.457);}
.SystemMessage p span{color: yellow;transition: all 1000ms;}
.SlowlyUnfold {animation: SlowlyUnfold 1000ms linear forwards;display: block ruby;}
.hidelyUnfold {animation: HidelyUnfold 1000ms linear forwards;display: block ruby;}
@keyframes SlowlyUnfold{
  0%{transform: translateY(-30px);height: 0}
  100%{transform: translateY(0px);height: 30px;}
}
@keyframes HidelyUnfold{
  0%{transform: translateY(0px);height: 30px;}
  100%{transform: translateY(-30px);height: 0}
}
</style>
